// Simple Promise that waits for the passed duration
export default (duration) =>
  new Promise((resolve) => {
    setTimeout(() => resolve(), duration);
  });
